var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometerVeryHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 41,
    viewBox: "0 0 21 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5114 23.0463V7.16664C17.5114 3.48477 14.5266 0.5 10.8447 0.5C7.16285 0.5 4.17809 3.48477 4.17809 7.16664V23.0463C2.13223 24.8773 0.844727 27.5384 0.844727 30.5C0.844727 36.0229 5.32191 40.5 10.8447 40.5C16.3675 40.5 20.8447 36.0229 20.8447 30.5C20.8447 27.5384 19.5572 24.8773 17.5114 23.0463ZM10.8447 37.1666C7.16285 37.1666 4.17809 34.1819 4.17809 30.5C4.17809 28.5752 4.99379 26.7897 6.40113 25.5301L7.51145 24.5363V7.16664C7.51145 5.3257 9.00387 3.83328 10.8448 3.83328C12.6857 3.83328 14.1782 5.32562 14.1782 7.16664V24.5363L15.2885 25.5301C16.6958 26.7897 17.5115 28.5752 17.5115 30.5C17.5114 34.1819 14.5266 37.1666 10.8447 37.1666Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5116 7.29201C12.5145 7.2516 12.516 7.21079 12.516 7.16963C12.516 6.24752 11.7683 5.5 10.846 5.5C9.92371 5.5 9.17603 6.24752 9.17603 7.16963C9.17603 7.19861 9.17676 7.22741 9.17822 7.25603V25.7866C7.23615 26.4728 5.84473 28.3245 5.84473 30.5011C5.84473 33.2619 8.0833 35.5 10.8447 35.5C13.6062 35.5 15.8447 33.2619 15.8447 30.5011C15.8447 28.3246 14.4535 26.473 12.5116 25.7867V7.29201Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerVeryHigh);
export default __webpack_public_path__ + "static/media/thermometer_very_high.26f1370384de16bd2c80ba97aab6df06.svg";
export { ForwardRef as ReactComponent };